export default __webpack_public_path__ + "static/media/instagram_2.46aca4d1.png";